import { CircularProgress } from "@mui/material";
import API from "../Utils/Interceptor/ApiMiddleware";
import { useEffect, useState } from "react";
import CustomSnackbar from "../components/Composables/CustomSnackBarMenu";

const Logout = () => {
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  useEffect(() => {
    const logoutUser = async () => {
      try {
        await API.post("/auth/logout", {}, { withCredentials: true });
        localStorage.clear();
        setSnackbar({
          open: true,
          message: "Logout successful",
          severity: "success",
        });
        setTimeout(() => {
          window.location.href = "/login";
        }, 500);
      } catch (error) {
        console.error("Logout failed:", error);
        localStorage.clear();
        window.location.href = "/login";
      }
    };

    logoutUser();
  }, []);

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 9999,
        }}
      >
        <CircularProgress />
      </div>
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          pointerEvents: "none",
        }}
      />
      <CustomSnackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      />
    </>
  );
};

export default Logout;
